import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit6-introduction',
  templateUrl: './unit6-introduction.component.html',
  styleUrls: ['./unit6-introduction.component.css']
})
export class Unit6IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
